var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatrolInspectionComponent',{attrs:{"typeName":"巡回清掃 報告書項目設定","type":2,"settionStrageName":"RoundInspectionStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }